import React from 'react';
import { Route, Routes,useLocation } from 'react-router-dom';
import Login from './../pages/login/Login';
import Home from './../pages/home/Home';
import NotFound from './../pages/not-found/NotFound';
import ForgotPassword from './../pages/forgot-password/ForgotPassword';
import Switch from './../pages/switch/Switch';
import OrgUsers from './../pages/org-users/OrgUsers';
import PrivateRoute from './Private';
import { isLogedIn } from '../services/AuthService';
import { withApplication } from '../services/PendingApplication';

const isAdmin = () => {
  if (!isLogedIn()) return false;
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.role === 1 || user.role === 2;
  } catch {
    return false;
  }
};

const AppRoutes: React.FC<any> = () => {
  const location = useLocation();
  return (
    <Routes>
      {/* isLogedIn() only inspects localStorage, so a user whose SSO session
          already died server-side is bounced to /home from here. That bounce
          must carry the query string: dropping it loses the ?application=
          handoff, and the user ends up back on this login page with no way to
          know which app they came from. */}
      <Route path="/" element={ <PrivateRoute element={<Login />} isAuthenticated={!isLogedIn()} to={withApplication(`/home${location.search}`)} />} ></Route>
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/switch" element={<Switch />} />
      <Route path="/home" element={ <PrivateRoute element={<Home />} isAuthenticated={isLogedIn()} to={withApplication(`/${location.search}`)} />} ></Route> //dashboard
      <Route path="/org/users" element={ <PrivateRoute element={<OrgUsers />} isAuthenticated={isAdmin()} to={"/home"} />} />
      <Route path="*" element={<NotFound />} /> {/* Use element prop here */}
    </Routes>
  );
};

export default AppRoutes;